import { balanceUpEnrollIcon, plusWhiteIcon, vIcon } from '../../assets/svg/index';

export const STYLES = {
  APP_LAYOUT: 'bg-bw02 h-screen pl-[72px] pt-[78px] pb-20 flex flex-col fadeIn',
  BACK_BUTTON: 'flex items-center justify-center w-[2rem]',
  NAV_HEADER: 'flex items-start mb-6',
  NAV_TITLE: 'text-bw08 font-metricMedium text-xl',
  MAIN_CONTENT:
    'relative flex flex-col px-[40px] py-[40px] pb-[20px] bg-bw00 rounded-lg w-full max-h-[548px] min-h-[431px]',
  SUB_CONTENT: 'flex flex-col relative p-[40px] bg-bw00 rounded-lg w-[456px] h-[515px]',
  STEP_TITLE: 'font-metricMedium text-lg mb-[24px] text-bw08 max-w-[320px]',
  STEP_DISCLAIMER: 'text-bw07 text-sm font-metric max-w-[262px]',
  STEP_DASHBOARD: {
    CONFIRMATION_CHILD: {
      WRAPPER: 'fadeIn w-[400px] py-[66px] px-[50px] pb-[30px] bg-bw00 rounded-[8px] flex flex-col items-center',
      ICON: 'w-[84px] mb-[24px]',
      HEADER: 'text-base leading-[27px] font-metricMedium text-bw08 mb-[21px]',
      SUB_HEADER: 'font-metric text-center text-bw07 leading-[27px] mb-[89px]',
      MAIN_CTA:
        'w-[240px] h-[50px] flex items-center justify-center rounded-umd bg-action03 hover:bg-action04 font-metricMedium text-bw00 text-[14px] leading-[25px]',
      SECONDARY_CTA:
        'w-[278px] h-[22px] flex items-center justify-center bg-transparent font-metric text-base leading-[22px] text-bw07 mt-[17px]',
    },
    HAPPY_STATE: {
      CONTAINER: 'flex flex-col items-center relative',
      DONUT: {
        CURRENCY_SIGN: '$',
        SIZE: 142,
        STROKE_WIDTH: 6,
        PERCENTAGE_CLASS_NAME: 'text-[36px] text-action03 font-metricBold leading-[43px]',
      },
      TEXTS: {
        LINE_1: 'leading-[18px] font-metric text-base text-bw05 mt-[24px]',
        LINE_2: 'leading-[38px]font-metric text-[24px] text-bw07 mt-[20px] mb-[142px]',
      },
    },
    NON_ELIGIBLE: {
      CONTAINER: 'flex flex-col items-center',
      CIRCLE:
        'w-[142px] h-[142px] bg-action01 rounded-full flex items-center justify-center mb-[24px] text-[24px] font-metricMedium text-bw07',
      TEXT: 'leading-[18px] font-metric text-base text-bw07 mb-[46px]',
      FOOTER: 'mt-[40px]',
    },
    ADD_MONEY_WIDGET: {
      CONTAINER: 'w-full h-[128px] bg-action03 bg-opacity-20 rounded-[2px] pl-[24px] pt-[20px] flex flex-col',
      TITLE: 'font-metric text-[18px] leading-[18px] text-action03 mb-[6px]',
      TEXT: 'font-metric text-base leading-[22px] text-bw07 mb-[11px]',
      CTA: 'flex justify-center items-center bg-action03 hover:bg-action04 w-[166px] h-[41px] rounded-umd text-bw00 font-metricMedium text-xxs',
      CTA_ICON: 'w-[16px] h-[16px] mr-[4px]',
    },
  },
  STEP_ICON: 'w-[120px] mb-[24px]',
  ENROLL_HAPPY_FLOW_WRAPPER: 'flex flex-col h-full',
  INFO_BULLET: {
    BG_COLOR: '#BFE7EA',
    TITLE_COLOR: 'action03',
    CONTENT: 'font-metric text-base text-bw07 leading-[22px] max-w-[270px]',
  },
  BALANCE_UP_FOOTER: {
    SPINNER: {
      HEIGHT_WIDTH: '20px',
    },
    TOGGLE_BUTTON: {
      OUT: 'w-[3rem] h-[1.5rem] px-1 rounded-2xl flex items-center',
      OUT_ON: 'flex-row-reverse bg-action02 bg-opacity-50',
      OUT_OFF: 'flex-row bg-bw03',
      IN: 'w-[1.125rem] h-[1.125rem] rounded-full',
      IN_ON: 'bg-action03 bg-opacity-100',
      IN_OFF: 'bg-bw06',
    },
    TEXT_CSS: 'font-metric text-base text-bw08',
    STATE_CSS: 'font-metricSemibold',
    CONTAINER: 'w-[456px] h-[50px] pl-[41px] pr-[33px] flex justify-between border-t border-bw03 pt-[23px]',
  },
  STEP_CONFIRMATION: {
    CONTAINER: 'flex flex-col h-full',
    LOTTIE: 'w-[76px] h-[76px] mb-[24px]',
    TITLE: 'mb-[24px] text-bw08 font-metricMedium text-[20px] max-w-[350px]',
    TEXT: 'text-bw07 text-base font-metric max-w-[315px]',
    DISCLAIMER: 'mt-[78px] text-bw05 text-sm font-metric max-w-[315px]',
  },
};

export const PAGE_TITLE = 'BalanceUp';

export const BALANCE_UP_STEPS_DATA = {
  ENROLLMENT: {
    STEP_ID: 1,
    NEXT_STEP_ID: 2,
    ICON_SRC: balanceUpEnrollIcon,
    TITLE: 'BALANCE_UP_HAPPY_FLOW_TITLE',
    DISCLAIMER: 'BALANCE_UP_HAPPY_FLOW_DISCLAIMER',
    ACTIONS: [
      {
        TITLE: 'BALANCE_UP_HAPPY_FLOW_CTA_TEXT',
        STYLES:
          'bg-action03 w-fit min-w-[240px] text-bw00 hover:bg-action04 font-metricMedium text-base py-[13px] px-[34px] rounded-[3px] mt-auto',
      },
    ],
    REQ_ACH_DATA: {
      TITLE: 'BALANCE_UP_REQ_ACH_TITLE',
      infoBullets: [
        {
          title: '1',
          content: 'BALANCE_UP_REQ_ACH_INFO_BULLET_1',
        },
        {
          title: '2',
          content: 'BALANCE_UP_REQ_ACH_INFO_BULLET_2',
        },
        {
          title: '3',
          content: 'BALANCE_UP_REQ_ACH_INFO_BULLET_3',
        },
      ],
      ACTIONS: [
        {
          TITLE: 'BALANCE_UP_REQ_ACH_CTA_TEXT',
          STYLES:
            'bg-action03 w-fit min-w-[240px] text-bw00 hover:bg-action04 font-metricMedium text-base py-[13px] px-[34px] rounded-[3px] mt-auto',
        },
      ],
    },

    NEED_TO_UPGRADE: {
      TITLE: 'BALANCE_UP_UPGRADE_TO_PRO_TITLE',
      NEXT_STEP_ID: 'upgrade flow',
      ACTIONS: [
        {
          TITLE: 'BALANCE_UP_UPGRADE_TO_PRO_CTA_TEXT',
          STYLES:
            'bg-action03 w-fit min-w-[240px] text-bw00 hover:bg-action04 font-metricMedium text-base py-[13px] px-[34px] rounded-[3px] mt-auto',
        },
      ],
      infoBullets: [
        {
          title: '1',
          content: 'BALANCE_UP_UPGRADE_TO_PRO_INFO_BULLET_1',
        },
        {
          title: '2',
          content: 'BALANCE_UP_UPGRADE_TO_PRO_INFO_BULLET_2',
        },
        {
          title: '3',
          content: 'BALANCE_UP_UPGRADE_TO_PRO_INFO_BULLET_3',
        },
        {
          title: '4',
          content: 'BALANCE_UP_UPGRADE_TO_PRO_INFO_BULLET_4',
        },
      ],
    },
  },
  CONFIRMATION: {
    STEP_ID: 2,
    NEXT_STEP_ID: 3,
    ICON_SRC: vIcon,
    TITLE: 'BALANCE_UP_CONFIRMATION_TITLE',
    TEXT: 'BALANCE_UP_CONFIRMATION_TEXT',
    DISCLAIMER: 'BALANCE_UP_CONFIRMATION_DISCLAIMER',
    ACTIONS: [
      {
        TITLE: 'BALANCE_UP_CONFIRMATION_ACTION_0',
        STYLES:
          'bg-action03 w-[240px] h-[50px] text-bw00 hover:bg-action04 font-metricMedium text-base rounded-[3px] mt-auto',
      },
    ],
  },
  BALANCE_UP_DASHBOARD: {
    ADD_MONEY: {
      TITLE: 'BALANCE_UP_ADD_MONEY_WIDGET_TITLE',
      TEXT: 'BALANCE_UP_ADD_MONEY_WIDGET_TEXT',
      CTA_TEXT: 'BALANCE_UP_ADD_MONEY_WIDGET_CTA',
      CTA_ICON: plusWhiteIcon,
      NAV_PATH: '/ach-transfer',
    },
    STEP_ID: 3,
    TITLE: 'BALANCE_UP_DASHBOARD_SUB_CONTENT_HEADER',
    TEXT: {
      STYLES: {
        CONTAINER: 'flex gap-[12px]',
        CIRCLE: 'w-[6px] h-[6px] mt-[7px] bg-action03 rounded-full',
        ITEM: 'w-full leading-[22px] text-base font-metric text-bw07 whitespace-pre-line mb-[24px]',
      },
      ITEMS: [
        'BALANCE_UP_DASHBOARD_SUB_CONTENT_ITEM_1',
        'BALANCE_UP_DASHBOARD_SUB_CONTENT_ITEM_2',
        'BALANCE_UP_DASHBOARD_SUB_CONTENT_ITEM_3',
        'BALANCE_UP_DASHBOARD_SUB_CONTENT_ITEM_4',
      ],
    },
  },
} as const;

export const BALANCE_UP_STEPS_MAP = {
  ZERO_STATE: 0,
  ENROLLMENT: 1,
  CONFIRMATION: 2,
  BALANCE_UP_DASHBOARD: 3,
} as const;

export const ENROLLMENT_TYPES = {
  ACC_UPGRADE_REQ: 'ACC_UPGRADE_REQ',
  ACH_TRANSFER_REQ: 'ACH_TRANSFER_REQ',
  HAPPY_FLOW_ENROLL: 'HAPPY_FLOW_ENROLL',
} as const;

export const DYNAMIC_HEIGHTS = {
  SMALL: 'h-[431px]',
  MEDIUM: 'h-[515px]',
  HIGH: 'h-[548px]',
} as const;

export const BALANCE_UP_DASHBOARD_TEXTS = {
  NOT_ELIGIBLE_TEXTS: {
    TEXT: 'BALANCE_UP_DASHBOARD_NOT_ELIGIBLE_TEXT',
  },
  HAPPY_STATE_TEXTS: {
    LINE_1: 'BALANCE_UP_DASHBOARD_HAPPY_STATE_TEXT1',
    LINE_2: 'BALANCE_UP_DASHBOARD_HAPPY_STATE_TEXT2',
  },
} as const;

export const BALANCE_UP_DASHBOARD_FOOTER_TEXTS = {
  TEXT: 'BALANCE_UP_DASHBOARD_FOOTER_TOGGLE_TEXT',
  STATE_ON: 'BALANCE_UP_DASHBOARD_FOOTER_TOGGLE_STATE_ON',
  STATE_OFF: 'BALANCE_UP_DASHBOARD_FOOTER_TOGGLE_STATE_OFF',
} as const;
export const SEARCH_VALUE_MAX_OVER_DRAFT = 'MAX_OVER_DRAFT';
